import { InsightStatusPath } from '@pages/cooper-insights/models/insight-status-path.enum';
import { InsightStatus } from '@layout/insight/models/insight-status.enum';
import { InsightsRoute } from '@pages/cooper-insights/models/route/insights-route.interface';

export const cooperInsightsRoutes: InsightsRoute[] = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: `${InsightStatusPath.ToDo}`,
    data: {
      insightStatus: InsightStatus.ToDo,
      prefetchTarget: `${InsightStatusPath.ToDo}`,
    },
  },
  {
    path: `${InsightStatusPath.ToDo}`,
    loadComponent: () =>
      import('@pages/cooper-insights/components/insight-list/insight-list.component').then(
        ({ InsightListComponent }) => InsightListComponent
      ),
    data: {
      insightStatus: InsightStatus.ToDo,
    },
  },
  {
    path: `${InsightStatusPath.Completed}`,
    loadComponent: () =>
      import('@pages/cooper-insights/components/insight-list/insight-list.component').then(
        ({ InsightListComponent }) => InsightListComponent
      ),
    data: {
      insightStatus: InsightStatus.Completed,
    },
  },
  {
    path: `${InsightStatusPath.Snoozed}`,
    loadComponent: () =>
      import('@pages/cooper-insights/components/insight-list/insight-list.component').then(
        ({ InsightListComponent }) => InsightListComponent
      ),
    data: {
      insightStatus: InsightStatus.Snoozed,
    },
  },
];
